// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { fontConfig } from "@bg/XDL/PreStyle/typography";
import { sortSelectStyles } from "@insite/content-library/Widgets/ProductList/ProductListSortSelect";
import { css } from "styled-components";

// Styling of Product sort Select in PLP
sortSelectStyles.select = {
    labelProps: {
        css: css`
            padding-top: 0;
            padding-right: 8px;
            width: auto;
            font-weight: ${fontConfig.weight.bold};
            letter-spacing: 0;
            font-size: ${fontConfig.fontSize.small}px;
        `,
    },
    cssOverrides: {
        formField: css`
            display: flex;
            align-items: center;
            > div {
                margin-top: 0 !important;
                width: auto;
                max-width: 175px;
                flex: 1;

                select {
                    height: 32px;
                }
            }
        `,
    },
    iconProps: {
        css: css`
            top: 6px !important;
            padding: 1px 4px !important;
        `,
    },
};

// // End Styling of Product sort Select in PLP
